import React, { useCallback, useEffect } from 'react'

import { useState } from 'react'

import ChipIcon from '@/Icons/Chip'

import getFormStatus from '@/Form/Functions/getFormStatus'

import PhoneModal from '@Modal/PhoneModal'
import Modal      from '@Modal/V3/Modal'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'

import request from '@function/ajax/request'

export default function SoRewardCard ({ ...props })
{
	const [loading, setLoading] = useState('fetching');
	const [enabled, setEnabled] = useState(false);
	const [exists, setExists] = useState(false);
	const [status, setStatus] = useState({ });
	const [modal, setModal] = useState({ });

	const closeModal = useCallback(function (e)
	{
		setModal({ });
	},
	[]);

	useEffect(function ()
	{
		(async function ()
		{
			try
			{
				var { syner_kado, card_exists
				} = await request('/sorewards/get-user-status')
				.config({ })
				.post({ });
			}
			catch (e)
			{
				console.error(e);
			}

			setEnabled(syner_kado);
			setExists(card_exists);
			setLoading(false);
		})();
	},
	[]);

	const openCard = useCallback(function (e)
	{
		if (e) e.persist?.();

		setLoading('opening');

		(async function ()
		{
			try
			{
				var response = await request('/sorewards/open-card')
				.config({ timeout: 1 * 60 * 1000 })
				.post({ });
			}
			catch (update)
			{
				setStatus(update);

				return setLoading(false);
			}

			setLoading(false);

			if (response.redirect_to)
			{
				window.open(response.redirect_to, '_blank').focus();
			}
			else if (response.require_phone)
			{
				setModal({ open: true, trg: e?.target });
			}
		})();
	},
	[]);

	if (!loading && !enabled && !exists)
	{
		return getFormStatus(
		{
			error: 'Votre CSE ne vous propose pas l\'offre Syner\'Kado'
		});
	}

	const open_loader = loading === 'opening' ?
	(
		<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
	)
	: undefined;

	return (
		<div className="user-synerkado">
			<div className="c-syner-kado">
				<Image alt="" className="c-syner-kado__logo"
					src="/images/syner_kado.svg"
				/>
				<ChipIcon className="c-syner-kado__chip-icon" />
			</div>

			<div className="u-full-width">

				{ getFormStatus(status) }

				<button type="button" className="c-btn c-btn--extra c-btn--primary"
					onClick={ openCard }>
					Accéder à ma carte
					{ open_loader }
				</button>

			</div>

			<PhoneModal open={ modal?.open }
				trg={ modal?.trg }
				onSuccess={ openCard }
				onClose={ closeModal }
			/>
		</div>
	);
}